export default "__VITE_ASSET__27c1d93e__"